var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var PlacingStateMachine = require("./../../../abstract/stateMachines/placingStateMachine.js");

var LogoToolStateMachine = function (root, editorModel, selectionModel, dataCollection, options) {
    this.root = root;
    this.collection = dataCollection;
    this.options = options;

    PlacingStateMachine.call(this, root, editorModel, selectionModel);
};

lib_core.inherit(LogoToolStateMachine, PlacingStateMachine);

module.exports = LogoToolStateMachine;

LogoToolStateMachine.prototype.createElement = function (startCoord) {
    var elementData = new cio_datamodel.LogoData(this.root, startCoord, 0, 1, 1);
    elementData.type("svg");
    elementData.data("<g id=\"g7284\" transform=\"translate(-427.80682,-130.3764)\"><rect height=\"2.5\" id=\"rect8544\" style=\"fill:#000000;stroke:#000000;stroke-width:0.99999994\" width=\"13\" x=\"421.30685\" y=\"133.94202\"/><path d=\"m 434.30683,124.19202 -6.5,11 -6.5,-11 z\" id=\"path8546\" style=\"fill:#000000;stroke:#000000;stroke-width:1;stroke-linecap:round\"/><line id=\"line8548\" style=\"fill:#ffffff;stroke:#000000;stroke-width:1;stroke-linecap:round\" x1=\"427.80685\" x2=\"427.80685\" y1=\"124.19202\" y2=\"113.25141\"/><line id=\"line8550\" style=\"fill:#ffffff;stroke:#000000;stroke-width:1;stroke-linecap:round\" x1=\"427.80685\" x2=\"427.80685\" y1=\"136.44202\" y2=\"147.50134\"/></g>");

    var collection = this.collection;
    if (collection.isSet()) collection.add(elementData);
    else if (collection.isList()) collection.push(elementData);
    else console.warn("Cannot add item to a collection that is not a list or a set");

    var interactionModel = this.editorModel.interactionModelDataMap.get(elementData);

    return interactionModel;
};
